import React, { useState } from 'react';
import { makeStyles } from "@material-ui/core/styles";
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import { useTranslation } from 'react-i18next';
import { dataService } from '../../Services/data.service';
import EditRushOrderDialog from '../Shared/Dialogs/EditRushOrderDialog';
import FlagstoneTheme from '../../Config/flagstoneTheme';
import { toast } from 'react-toastify';

export default function OrderDetailAssignment(props) {
    const classes = useStyles();

    const { t } = useTranslation();
    const [editRushOrderDialogOpen, setEditRushOrderDialogOpen] = useState(false)
    const [dialogValue, setDialogValue] = useState(null);

    const rows = [
        createData('Article', props.productionOrder.bomOut[0].productName),
        createData('Pieces', props.productionOrder.bomOut[0].quantityToProduce),
        createData('Colour', JSON.parse(props.productionOrder.metaData).find(x => x.MetaDataType === 1).MetaData[0]),
        createData('Body', JSON.parse(props.productionOrder.metaData).find(x => x.MetaDataType === 1).MetaData[0]),
        createData('Lens', JSON.parse(props.productionOrder.metaData).find(x => x.MetaDataType === 1).MetaData[0])
    ];

    function createData(name, info) {

        let editable = false
        if (name === 'Colour') {
            info = "<b>Cover: </b>" + info.CoverColor +" , <b>Body: </b>" + info.BodyColor + " , <b>Lens: </b>" + info.LensColor;
            if (props.editable) {
                editable = true
            }
        }

        if (name === 'Body') {
            info = info.Body
            if (props.editable) {
                editable = true
            }
        }

        if (name === 'Lens') {
            info = info.Lens
        }

        return { name, info, editable };
    }


    const changeRushOrder = (changedValue, value, value2, value3) => {

        let metaData = JSON.parse(props.productionOrder.metaData)
        if (changedValue === 'Body') {
            metaData.find(x => x.MetaDataType === 1).MetaData[0].Body = value
        }
        else {
            metaData.find(x => x.MetaDataType === 1).MetaData[0].CoverColor = value
            metaData.find(x => x.MetaDataType === 1).MetaData[0].BodyColor = value2
            metaData.find(x => x.MetaDataType === 1).MetaData[0].LensColor = value3
        }

        props.productionOrder.metaData = JSON.stringify(metaData)

        for (let bomIn of props.productionOrder.bomIn) {
            let metaData = JSON.parse(bomIn.bomMetaData)
            if (changedValue === 'Body') {
                if (metaData.find(x => x.MetaDataType === 1).MetaData[0].Length) {
                    metaData.find(x => x.MetaDataType === 1).MetaData[0].Length = value
                }
            }
            else {
                if (metaData.find(x => x.MetaDataType === 1).MetaData[0].CoverColor) {
                    metaData.find(x => x.MetaDataType === 1).MetaData[0].CoverColor = value
                }
                if (metaData.find(x => x.MetaDataType === 1).MetaData[0].BodyColor) {
                    metaData.find(x => x.MetaDataType === 1).MetaData[0].BodyColor = value2
                }
                if (metaData.find(x => x.MetaDataType === 1).MetaData[0].LensColor) {
                    metaData.find(x => x.MetaDataType === 1).MetaData[0].LensColor = value3
                }
            }

            bomIn.bomMetaData = JSON.stringify(metaData)
        }


        dataService.updateProductionOrderMetaData(props.productionOrder).then(
            setTimeout(() => props.refreshOrder(),1000)
        ).catch((error) => { toast.error(error, { position: toast.POSITION.TOP_CENTER }) })
    }

    const editValue = (valueName) => {
        setDialogValue(valueName)
        setEditRushOrderDialogOpen(true)
    }

    return <div className={classes.orderDetailAssignment}>
        <div className={classes.title}>
            {t('Assignment')}
        </div>
        <TableContainer component={Paper} className={classes.paper}>
            <Table className={classes.table} aria-label="customized table">
                <TableBody>
                    {rows.map((row) => (
                        <TableRow key={row.name} className={classes.row}>
                            <TableCell className={classes.nameCell}>
                                {row.name}
                            </TableCell>
                            <TableCell className={classes.infoCell}><div className={classes.rowInfo} dangerouslySetInnerHTML={{__html: row.info}}></div>
                                {row.editable ? <button className={classes.editButton} onClick={() => editValue(row.name)}>{"Edit"}</button>
                                    :
                                    <React.Fragment></React.Fragment>}
                            </TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        </TableContainer>
        <EditRushOrderDialog productionOrder={props.productionOrder} changeRushOrder={changeRushOrder} dialogOpen={editRushOrderDialogOpen} closeDialog={() => setEditRushOrderDialogOpen(false)} dialogValue={dialogValue}></EditRushOrderDialog>
    </div>
}

const useStyles = makeStyles({
    nameCell: {
        padding: "3px !important",
        border: "none",
        fontSize: "16px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'bold',
        color: "#020100",
    },
    infoCell: {
        padding: "3px !important",
        border: "none",
        fontSize: "16px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'medium',
        color: "#020100",
        height:"30px",
        display:"flex"
    },
    rowInfo: {
        flexGrow: "4"
    },
    paper: {
        boxShadow: 'none'
    },
    title: {
        fontSize: "22px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'medium',
        color: "#020100",
        marginBottom: "15px"
    },
    orderDetailAssignment: {
        padding: "20px",
        height: "auto"
    },
    row: {
        '&:nth-of-type(odd)': {
            backgroundColor: "#F4F4F4",
        },
    },
    editButton: {
        backgroundColor: "#4654FB22",
        height: "25px",
        fontSize:"16px",
        borderRadius: "5px",
        width:"50px",
        fontWeight:"bold",
        border: "none",
        outline: "none",
        cursor: "pointer",
        color: FlagstoneTheme.palette.primary.main,
        float: "right"
    }
});